import { AddDashboardWidgetsParams, BuildDashboardContext } from './types';
import { addWidgetsToExistingDashboard } from '@/services/dashboards/dashboards-service';
import { WidgetProps } from '@sisense/sdk-ui';
import { devDebug } from '@/utils/dev-debug';

export const addDashboardWidgets = async (
	{ dashboardId, widgetIdsToAdd }: AddDashboardWidgetsParams,
	context: BuildDashboardContext,
) => {
	const { retrieveDashboard, saveDashboard, getWidgetList } = context;
	devDebug('toolCall', {
		tool: 'addDashboardWidgets',
		dashboardId,
		widgetIdsToAdd,
	});

	const currentDashboard = retrieveDashboard?.(dashboardId);
	if (!currentDashboard) {
		throw new Error('Dashboard not found');
	}

	let newWidgetList: WidgetProps[] = [];
	try {
		newWidgetList = getWidgetList?.(widgetIdsToAdd) || [];
	} catch (error) {
		console.error(
			'Error: Failed to locate input chart widgets. Empty widget list will be used.',
			error,
		);
	}
	const dashboardProps = addWidgetsToExistingDashboard(
		currentDashboard,
		newWidgetList,
	);

	saveDashboard?.(dashboardProps);

	return {
		message:
			newWidgetList.length > 0
				? 'Widgets added successfully. Click "Save" to persist changes to My Dashboards.'
				: widgetIdsToAdd.length > 0
				? 'Widgets cannot be located. Try to create chart widgets one by one and add them to the dashboard.'
				: 'Widgets cannot be located. Run the recommend queries tool and add them all as widgets to the dashboard.',
	};
};
